export default __webpack_public_path__ + "static/media/care_device_edit.c22a1d01.svg";